<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <Breadcrumbs main="Home" title="default" />

  <div class="container-fluid p-0">
    <div class="row widget-grid">
      <!-- <Filter
        :stateProp="stateList"
        @filterHandle="filterHandle"
        :hasCustomDate="true"
        :hasPeriod="false"
        :hasLocation="true"
        :applyMPs="true"
        :periodNameProp="`Current MP`"
      /> -->

      <el-row span="24" :class="$vuetify.display.width < 750 ? 'm-0 width-100-p mt-10' : 'm-0 width-100-p mt-10'">
        <el-col :span="filterButtonOpenClose || $vuetify.display.width < 600 ? 24 : 8">
          <div class="pr-20">
            <FilterS1HomePage
              :stateProp="stateList"
              :periodNameProp="`Current MP`"
              @filterHandle="filterHandle"
              @buttonOpenClose="buttonOpenClosehandle"
            />
          </div>
        </el-col>
        <!-- new pdf and cache button -->
        <el-col
              class="p-0"
              :span="filterButtonOpenClose || $vuetify.display.width < 600 ? 24 : 16"
              :class="
                $vuetify.display.width < 450
                  ? 'pr-20 mb-10 order-1 width-100-p pr-10 d-flex x-end'
                  : 'd-flex justify-content-end pr-10 mb-10'
              "
            >
            <div class="bg-me-primary border-color-light align-item-center home-button-wrapper">
              <el-button @click="handleExport"
                    class="home-export-to-pdf-btn"
                >
                    <svg class="pdf-svg">
                    <use
                        href="@/assets/svg/newSvgIcon.svg#homeExportToPdfButton"
                    ></use>
                    </svg>
                </el-button>
              <!-- export file button -->
              <el-button
                @click="handleClearCache"
                class="home-clear-cache-btn"
              >
                <svg class="clear-cache-svg">
                  <use href="@/assets/svg/newSvgIcon.svg#homeClearCacheButton"></use>
                </svg>
              </el-button>
            </div>

        </el-col>
      </el-row>
      <el-row span="24" :class="$vuetify.display.width < 750 ? 'm-0 width-100-p m-t-4' : 'm-0 width-100-p m-t-8'" >

        
        <!-- Abatement -->
        <el-col
          class="d-flex align-item-center px-2"
          :span="$vuetify.display.width >= 1500 ? 16 : 24"
        >
          <div
            class="row m-0 bg-me-primary border-color-light width-100-p rounded-4 d-flex flex-row flex-wrap"
            :style="$vuetify.display.width >= 1500 ? '' : 'padding-bottom: 30px'"
          >
            <el-col :span="24"
              :style="'padding: 20px;'"
              >
              <h5 class="text-white mt-3 ml-1">
                Abatement (tCO2-e)
                <el-text v-if="lastUpdateHighlights" tag="sub" size="small" class="pl-2 text-white">
                  <span class="text-white">Last updated: {{ lastUpdateHighlights }}</span>
                </el-text>
              </h5>
            </el-col>
            <!-- Abatement Chart -->
            <el-col
              v-loading="loadingChart"

              :style="$vuetify.display.width >= 700
                ? {
                    flex: '2',
                    minWidth: '600px',
                    maxWidth: '100%',
                  } : {
                    flex: '2',
                    minWidth: '350px',
                    maxWidth: '100%',
              }"
            >
              <div id="chart" v-if="!loadingChart">
                <apexchart
                  :key="chartKey"
                  type="line"
                  height="350"
                  :options="chartOptionsAbatement"
                  :series="seriesAbatement"
                ></apexchart>
              </div>
              <!-- <newChart /> -->
            </el-col>
            <!-- Abatement Card -->
             <el-col
              class="y-center"

                      :style="{
                    flex: '1',
                    minWidth: '300px',
                    maxWidth: '100%',
                    paddingBottom: '30px',
                  }"
            ><AbatementCard :dataProp="abatementData" />
          </el-col>
            
          </div>
        </el-col>
        <!-- History -->
        <el-col
          v-if="$vuetify.display.width >= 500"
          class="d-flex align-item-center px-2"
          :span="$vuetify.display.width >= 1500 ? 8 : 24"
          :class="$vuetify.display.width < 1500 ? 'mt-20' : ''"

        >
          <div
            class="row m-0 bg-me-primary border-color-light width-100-p rounded-4"
          >
            <el-col 
            :span="24" 
            :style="'margin: 20px'"
            >
             <el-row>
              <el-col :span="12">
                <h5 class="text-white mt-3 ml-1"  >Project Abatement History</h5>
              </el-col>
              <el-col :span="12" class="x-end pr-20">
                <el-button
                    color="#ddf0ac"
                    @click="handleRefreshAbatementHistory"
                    class="height-40 rounded-3 width-100 pr-3"
                  >
                    <svg class="stroke-icon width-20 height-20">
                      <use
                        href="@/assets/svg/icon-sprite.svg#stroke-refresh"
                      ></use>
                    </svg>
                    <span class="moderat-btn-apply pl-2"> Refresh </span>
                  </el-button>
              </el-col>
              <el-col :span="24">
                <el-text tag="sub" size="small" class="pl-2 text-white">
                <span class="text-white">* Please refresh this table manually to see the latest data</span><br>
                <span class="text-white">Last Update : {{ lastUpdateAbatement }}</span>
              </el-text>
              </el-col>
             </el-row>
            </el-col>

            <el-col :span="24">
              <div id="chart">
                <HistoryCard :dataProp="historyData" />
              </div>
            </el-col>
            <el-col :span="24">
              
              <!-- <div id="chart" v-if="!loadingHistoryChart">
                <apexchart
                  :key="chartKey"
                  type="bar"
                  height="350"
                  :options="chartOptionsHistory"
                  :series="seriesHistory"
                ></apexchart>
              </div> -->
              <!-- uncomment this to use the donut chart when wallet is  enabled -->
              <!-- <div id="chart" v-if="!loadingHistoryChart">
                <apexchart
                  :key="chartKey"
                  type="donut"
                  height="200"
                  :options="chartOptionsHistory"
                  :series="seriesHistory"
                ></apexchart>
              </div> -->
            </el-col>
          </div>
        </el-col>

        <!-- History mobile version -->
        <el-col
          v-else
          class="d-flex align-item-center px-2"
          :span="$vuetify.display.width >= 1500 ? 8 : 24"
          :class="$vuetify.display.width < 1500 ? 'mt-20' : ''"
        >
          <div
            class="row m-0 bg-me-primary border-color-light width-100-p rounded-4"
          >
            <el-col 
            :span="24" 
            :style="'margin: 20px'"
            >
            <el-row>
              <el-col :span="12">
                <h5 class="text-white mt-3 ml-1"  >Project Abatement History</h5>
              </el-col>
              <el-col :span="12" class="x-end pr-20">
                <el-button
                    color="#ddf0ac"
                    @click="handleRefreshAbatementHistory"
                    class="height-40 rounded-3 width-100 pr-3"
                  >
                    <svg class="stroke-icon width-20 height-20">
                      <use
                        href="@/assets/svg/icon-sprite.svg#stroke-refresh"
                      ></use>
                    </svg>
                    <span class="moderat-btn-apply pl-2"> Refresh </span>
                  </el-button>
              </el-col>
              <el-col :span="24">
                <el-text tag="sub" size="small" class="pl-2 text-white">
                <span class="text-white">* Please refresh this table manually to see the latest data</span><br>
                <span class="text-white">Last Update : {{ lastUpdateAbatement }}</span>
              </el-text>
              </el-col>
             </el-row>
            </el-col>
            <el-col :span="24">
              <div id="chart">
                <HistoryCardMobile :mobileDataProp="historyData" />
              </div>
            </el-col>
            <!-- <el-col :span="24">
              <div id="chart" v-if="!loadingHistoryChart">
                <apexchart
                  :key="chartKey"
                  type="bar"
                  height="120"
                  :options="chartOptionsHistory_mobile"
                  :series="seriesHistory_mobile"
                ></apexchart>
              </div>
            </el-col> -->
          </div>
        </el-col>

      </el-row>


      <DashboardCard :dataProp="abatementData" />

      <generatePDF 
      :key="pdfKey"
      :options="chartOptionsAbatement"                   
      :optionsHistory="chartOptionsHistory"    
      :seriesHistory="seriesHistory"
      :series="seriesAbatement" 
      :dataProp="abatementData" ref="childPdf" /> 

    </div>
  </div>



</template>

<script>
// import Filter from "../common/filter.vue";
import FilterS1HomePage from "../common/Filter-s1_homePage.vue";
import { ElMessageBox } from "element-plus";
import { createLoadingInstance } from "../common/common-tools";
import { abatementChart } from "./config.js";
import AbatementCard from "./abatementCard.vue";
import DashboardCard from "./dashboardCard.vue";
import HistoryCard from "./historyCard.vue";
import HistoryCardMobile from "./historyCardMobile.vue";
// import newChart from "./chart.vue";
import UserService from "../../../services/user.service";
import { isDirectComputeRequest } from "../../../services/highlights";
import { onUnmounted } from "vue";
import generatePDF from "./generatePDF.vue";
import { useToast } from "vue-toastification";
import {
  addTaskIdtoSessionStorage,
  createCeleryTaskPoller,
  removeTaskFromSessionStorage,
  updateTaskStatusInSessionStorage,
} from "../common/pollingCeleryTask";

export default {
  props: {
    propCardData: {
      type: Object,
      default: null,
    },
    propCardDataList: {
      type: Array,
      default: null,
    },
  },
  components: {
    // Filter,
    FilterS1HomePage,
    AbatementCard,
    DashboardCard,
    generatePDF,
    HistoryCard,
    HistoryCardMobile,
    // newChart,

  },
  watch: {
    propCardData: {
      handler: function (newValue) {
        this.cardData = newValue;
      },
      deep: true,
    },
    propCardDataList: {
      handler: function (newValue) {
        this.cardDataList = newValue;
      },
      deep: true,
    },
  },
  computed: {
    stateList() {
      return this.states;
    },
  },
  data() {
    return {
      filterButtonOpenClose: false,
      chartKey: 0,
      pdfKey: 0,
      selectedPeriod: "All",
      abatementData: null,
      loadingChart: false,
      loadingHistoryChart: false,
      states: [],
      filter: {
        country: "",
        elec_region: "",
        startDate: "",
        endDate: "",
        customer_id: null,
        site_name: null,
        mp_id: null,
        useCustomDateRange: false,
      },
      lastUpdateHighlights: null,
      seriesAbatement: abatementChart.seriesAbatement,
      chartOptionsAbatement: abatementChart.chartOptionsAbatement,

      seriesHistory: abatementChart.newSeriesHistory_issued,
      chartOptionsHistory: abatementChart.newChartOptionsHistory_issued,

      seriesHistory_mobile: abatementChart.newSeriesHistory_issued_mobile,
      chartOptionsHistory_mobile: abatementChart.newChartOptionsHistory_issued_mobile,

      historyData: {
        current: 0,
        under_audit: 0,
        issue_requested: 0,
      },

      lastUpdateAbatement: null,

      currentHeight: 0,
      currentWidth: 0,

      highlightsTaskId: null,
      highlightsPoller: null,
      highlightsPollWatchStops: [],
    };
  },
  beforeUnmount() {
    this.teardownHighlightsTask(null, { success: false });
  },
  async mounted() {
    // await this.updateCurrentMonitoringPeriod();
    // await this.fetchData();
    // await this.fetchAbatementHistory();
    window.addEventListener('beforeunload', () => {
      this.chartKey += 1; // 
  });

  onUnmounted(() => {
      this.chartKey += 1; // 
  });
    
  },

  methods: {

    // setVuetifyWidth() {
    //   this.$vuetify.display.width = 2250; // Temporarily override the display width
    // },

    scrollToTop() {
      this.currentWidth = window.outerWidth;
      this.currentHeight = window.outerHeight;

      // Scroll to top smoothly


      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 2000);


      setTimeout(() => {
          this.$vuetify.display.width = 2250;
          this.$vuetify.display.height = 1587;
        }, 4000);

      setTimeout(() => {
            this.$vuetify.display.width = this.currentWidth;
            this.$vuetify.display.height = this.currentHeight;
          }, 10000);
 
    },

    updatePdfKey() {
        this.pdfKey += 1; // force re-render the pdf component
    },

    
        async handleExport() {

          // this.setVuetifyWidth();
          // await this.updatePdfKey(); // force re-render the pdf component

          this.scrollToTop();
            // console.log("index receive pdf ");

            // await this.updatePdfKey(); // force re-render the pdf component

          setTimeout(()=>{
                console.log('start generated pdf');
                
                this.$refs.childPdf.generateReport();
            }, 5000);



            // this.$refs.childPdf.generateReport();
            
            
        },
    
    convertMonth(value) {
      const monthDict = {
        '1': 'Jan',
        '2': 'Feb',
        '3': 'Mar',
        '4': 'Apr',
        '5': 'May',
        '6': 'Jun',
        '7': 'Jul',
        '8': 'Aug',
        '9': 'Sep',
        '10': 'Oct',
        '11': 'Nov',
        '12': 'Dec',

        '01': 'Jan',
        '02': 'Feb',
        '03': 'Mar',
        '04': 'Apr',
        '05': 'May',
        '06': 'Jun',
        '07': 'Jul',
        '08': 'Aug',
        '09': 'Sep',
      };
      return monthDict[value] || value;
    },


    buildHighlightsBody() {
      const country = (this.filter.country || "").trim();
      const elec_region = (this.filter.elec_region || "").trim();
      const siteName = (this.filter.site_name || "").toString().trim();
      const body = {
        customer_id: this.filter.customer_id,
      };

      const hasCountryAndRegion =
        Boolean(country) && Boolean(elec_region) && elec_region.toUpperCase() !== "ALL";
      const hasCustomDates =
        this.filter.useCustomDateRange &&
        Boolean((this.filter.startDate || "").toString().trim()) &&
        Boolean((this.filter.endDate || "").toString().trim());
      const hasSite = Boolean(siteName);

      if (hasCustomDates || hasSite) {
        body.start_date = this.filter.startDate;
        body.end_date = this.filter.endDate;
      }
      if (hasSite) {
        body.site_name = siteName;
      }
      if (hasCountryAndRegion) {
        body.country = country;
        body.elec_region = elec_region;
      }

      if (hasCountryAndRegion || hasCustomDates || hasSite) {
        if (this.filter.mp_id) {
          body.mp_id = this.filter.mp_id;
        }
        return body;
      }

      body.mp_id = this.filter.mp_id;
      if (country) {
        body.country = country;
      }
      return body;
    },

    formatHighlightsUpdatedAt(updatedAt) {
      if (!updatedAt) {
        return null;
      }
      return String(updatedAt).replace("T", " ").substring(0, 19);
    },

    normalizeStatesFromHighlights(states) {
      if (!Array.isArray(states)) {
        return [];
      }
      return states
        .map((item) => (typeof item === "string" ? item : item && (item.elec_region || item.state)))
        .filter((s) => s != null && s !== "");
    },

    applyHighlightsPayload(payload, { showUpdatedAt = true } = {}) {
      if (!payload || !payload.summary) {
        return;
      }
      this.states = this.normalizeStatesFromHighlights(payload.states);
      this.abatementData = payload.summary;
      if (showUpdatedAt && payload.updated_at) {
        this.lastUpdateHighlights = this.formatHighlightsUpdatedAt(payload.updated_at);
      } else if (!showUpdatedAt) {
        this.lastUpdateHighlights = null;
      }
      this.fillForm();
    },

    clearHighlightsPolling() {
      if (this.highlightsPoller) {
        this.highlightsPoller.stopPolling();
        this.highlightsPoller = null;
      }
      if (Array.isArray(this.highlightsPollWatchStops)) {
        this.highlightsPollWatchStops.forEach((stop) => {
          if (typeof stop === "function") {
            stop();
          }
        });
        this.highlightsPollWatchStops = [];
      }
    },

    teardownHighlightsTask(taskId, { success = false, showToastOnSuccess = false } = {}) {
      this.clearHighlightsPolling();
      const tid = taskId != null ? taskId : this.highlightsTaskId;
      if (tid) {
        try {
          removeTaskFromSessionStorage(tid);
        } catch (e) {
          /* ignore */
        }
      }
      this.$store.dispatch("tasksProcessing/clearLoadingState", "dashboard_highlights");
      this.highlightsTaskId = null;
      this.loadingChart = false;
      if (success && showToastOnSuccess) {
        console.log("Dashboard highlights are ready.");
        // useToast().success("Dashboard highlights are ready.", {
        //   icon: "fa fa-check",
        //   position: "bottom-right",
        //   timeout: 4000,
        // });
      }
    },

    startHighlightsCachePoll(taskId) {
      this.highlightsTaskId = taskId;
      const poller = createCeleryTaskPoller(taskId, 5000);
      this.highlightsPoller = poller;
      let settled = false;

      const extractHighlightsPayload = (value) => {
        if (!value) {
          return null;
        }
        if (value.summary) {
          return value;
        }
        if (value.result && value.result.summary) {
          return value.result;
        }
        return null;
      };

      const finalizeSuccess = (payload) => {
        if (settled || !payload || !payload.summary) {
          return false;
        }
        settled = true;
        updateTaskStatusInSessionStorage(taskId, "SUCCESS", payload, null);
        this.applyHighlightsPayload(payload);
        this.teardownHighlightsTask(taskId, {
          success: true,
          showToastOnSuccess: true,
        });
        return true;
      };

      const stopResultWatch = this.$watch(
        () => poller.result.value,
        (result) => {
          if (String(poller.getStatus() || "").toUpperCase() !== "SUCCESS") {
            return;
          }
          const payload = extractHighlightsPayload(result);
          finalizeSuccess(payload);
        }
      );

      const stopStatusWatch = this.$watch(
        () => poller.taskStatus.value,
        async (st) => {
          const status = String(st || "").toUpperCase();
          if (!status) {
            return;
          }
          this.$store.dispatch("tasksProcessing/updateTaskStatus", {
            itemKey: "dashboard_highlights",
            status: st,
          });

          if (status === "SUCCESS") {
            try {
              const cachedResponse = await UserService.DashboardHomeData(this.buildHighlightsBody());
              const cached = cachedResponse && cachedResponse.data;
              if (cached && cached.summary && cached.cached === true) {
                if (finalizeSuccess(cached)) {
                  return;
                }
              }
            } catch (e) {
              console.error("Highlights cache refetch failed:", e);
            }
            if (finalizeSuccess(extractHighlightsPayload(poller.result.value))) {
              return;
            }
            try {
              const singleTaskResponse = await UserService.checkCeleryTaskStatus(taskId);
              const payload = extractHighlightsPayload(
                singleTaskResponse && singleTaskResponse.data
                  ? singleTaskResponse.data.result
                  : null
              );
              if (finalizeSuccess(payload)) {
                return;
              }
            } catch (e) {
              console.error("Highlights task result fetch failed:", e);
            }
            if (!settled) {
              settled = true;
              this.teardownHighlightsTask(taskId, { success: false });
              useToast().warning(
                "Highlights task finished but returned no usable data. Please try refreshing.",
                {
                  icon: "fa fa-clock-o",
                  position: "bottom-right",
                  timeout: 6000,
                }
              );
            }
            return;
          }

          if (status === "FAILURE" || status === "REVOKED") {
            if (settled) {
              return;
            }
            settled = true;
            this.teardownHighlightsTask(taskId, { success: false });
            useToast().error(
              "Dashboard highlights computation failed. Try again or adjust filters.",
              {
                icon: "fa fa-times",
                position: "bottom-right",
                timeout: 6000,
              }
            );
          }
        }
      );

      this.highlightsPollWatchStops = [stopResultWatch, stopStatusWatch];
      poller.startPolling();
    },

    fillForm() {
      this.loadingChart = true;
      this.seriesAbatement[0].data = [];
      this.seriesAbatement[1].data = [];
      this.seriesAbatement[2].data = [];
      this.chartOptionsAbatement.labels = [];

      this.abatementData.trends.forEach((value) => {
        this.chartOptionsAbatement.labels.push(this.convertMonth(value.month) + " " + value.year.toString().slice(-2)); // convert month to number to text, convert year to 2 digits
        this.seriesAbatement[0].data.push(value.cumulative_abatement_ex_month);
        this.seriesAbatement[1].data.push(value.abatement_);
        this.seriesAbatement[2].data.push(value.abatement_per_kWh_without_charger_efficiency);
      });
      
      setTimeout(() => {
        this.loadingChart = false;
      }, 300);
    },

    resetHistoryData() {
      this.historyData.current = 0;
      this.historyData.under_audit = 0;
      this.historyData.issue_requested = 0;
      this.seriesHistory = [0, 0, 0];
      this.seriesHistory_mobile[0].data = [0];
      this.seriesHistory_mobile[1].data = [0];
      this.seriesHistory_mobile[2].data = [0];
    },

    async fetchAbatementHistory() {
      await UserService.newfetchAbatementHistory()
        .then(
          (response) => {
            this.seriesHistory = [];
            // let tempData = [0, 0, 0];
            try {
              this.resetHistoryData();
              if (response.data && response.data.abatement_history && response.data.abatement_history.length !== 0) {
                // new request, reset card data first
                response.data.abatement_history.forEach((item) => {
                  const tonnes = item.total_credits_tonne ? parseFloat(item.total_credits_tonne) : 0;
                  if (item.status == "current") {
                    this.historyData.current += tonnes;
                  } else if (item.status == "under_audit") {
                    this.historyData.under_audit += tonnes;
                  } else if (item.status == "issue_requested") {
                    this.historyData.issue_requested += tonnes;
                  } else if (item.status == "revision_under_audit") {
                    this.historyData.under_audit += tonnes;
                  } else if (item.status == "revision_issue_requested") {
                    this.historyData.issue_requested += tonnes;
                  } else if (item.status == "issued") {
                    this.seriesHistory[0] += tonnes;
                  } else if (item.status == "sold") {
                    this.seriesHistory[1] += tonnes;
                  } else if (item.status == "retired") {
                    this.seriesHistory[2] += tonnes;
                  }
                })
              }
              // console.log("data into seriesHistory", this.seriesHistory[0]);
              this.lastUpdateAbatement = response.data.updated_at ? response.data.updated_at : response.data.message;
            } catch (error) {
              console.log('error when get abatement history', error.message);
              this.resetHistoryData();
              this.lastUpdateAbatement = error.response.data.message;
            }
          },
          (error) => {
            this.loadingHistoryChart = false;
            console.log(error.message);
            if (error.response && (error.response.status == 401 || error.response.status == 403)) {
              this.$router.push({
                path: "/",
              });
            } else if (error.response && error.response.status == 404) {
              console.log('error when get abatement history', error.message);
              this.resetHistoryData();
              this.lastUpdateAbatement = error.response.data.message;
            }
          }
        )
        .catch((error) => {
          this.loadingHistoryChart = false;
          console.log(error.message);
          if (error.response && (error.response.status == 401 || error.response.status == 403)) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loadingHistoryChart = false));
    },

    async fetchData() {
      this.clearHighlightsPolling();
      if (this.highlightsTaskId) {
        try {
          removeTaskFromSessionStorage(this.highlightsTaskId);
        } catch (e) {
          /* ignore */
        }
        this.$store.dispatch("tasksProcessing/clearLoadingState", "dashboard_highlights");
        this.highlightsTaskId = null;
      }

      const body = this.buildHighlightsBody();
      const directCompute = isDirectComputeRequest(body);
      if (!directCompute && !body.mp_id) {
        console.warn("Skipping highlights fetch: mp_id is required for cached MP flow.");
        this.loadingChart = false;
        this.lastUpdateHighlights = null;
        return;
      }

      this.loadingChart = true;

      try {
        const response = await UserService.DashboardHomeData(body);
        const data = response.data;

        if (data.summary && (data.cached === true || directCompute || !data.task_id)) {
          this.applyHighlightsPayload(data, {
            showUpdatedAt: !directCompute && data.cached === true,
          });
          return;
        }

        if (data.cached === false && data.task_id) {
          // useToast().info(
          //   data.message ||
          //     "Highlights are computing in the background; this page will update when ready.",
          //   {
          //     icon: "fa fa-info",
          //     position: "bottom-right",
          //     timeout: 6000,
          //   }
          // );
          addTaskIdtoSessionStorage(
            "dashboard_highlights",
            data.task_id,
            "PENDING",
            "reports",
            {}
          );
          this.startHighlightsCachePoll(data.task_id);
          return;
        }

        console.warn("Unexpected highlights response:", data);
        this.loadingChart = false;
      } catch (error) {
        this.loadingChart = false;
        this.lastUpdateHighlights = null;
        console.log(error);
        if (error.response && error.response.status === 401) {
          this.$router.push({
            path: "/",
          });
        } else if (error.response && error.response.status === 400) {
          useToast().error(
            error.response.data?.message || "Invalid highlights request",
            {
              icon: "fa fa-times",
              position: "bottom-right",
              timeout: 6000,
            }
          );
        }
      }
    },

    // clear cache
    async handleClearCache() {
      if (!this.filter.mp_id) {
        useToast().error("Please select a monitoring period before clearing highlights cache.", {
          icon: "fa fa-times",
          position: "bottom-right",
          timeout: 6000,
        });
        return;
      }

      const loading = createLoadingInstance();
      try {
        const response = await UserService.ClearHighlightsCache({
          customer_id: this.filter.customer_id,
          mp_id: this.filter.mp_id,
        });
        if(!response || !response.data){
          console.log("request error when clearing highlights cache");
          loading.close();
          return;
        }
        if (response.data.code == 1000){
          loading.close();
          const MessageBox = `
                  <span class="moderat-meGreen">Highlights cache cleared successfully.</span><br/>
                  `;
          
          await ElMessageBox.alert(MessageBox, {
                  confirmButtonText: "OK",
                  type: "success",
                  dangerouslyUseHTMLString: true,
                }).then(()=> {return;}).catch(()=>{return;});
          this.fetchData();
          return;
        } else {
          loading.close();
          console.log("Clearing highlights cache not successful");
          const MessageBox = `
                  <span class="moderat-meRed">Highlights cache cleared not successful.</span><br/>
                  `;
          return ElMessageBox.alert(MessageBox, {
                  confirmButtonText: "OK",
                  type: "warning",
                  dangerouslyUseHTMLString: true,
                }).then(()=> {return;}).catch(()=>{return;});
        }
      } catch (error) {
        loading.close();
        console.error("Error clearing highlights cache:", error.message);
        if (error.response && error.response.status === 403) {
          useToast().error("You do not have permission to clear highlights cache.", {
            icon: "fa fa-times",
            position: "bottom-right",
            timeout: 6000,
          });
        }
      }
    },

    async newUpdateAbatementHistory() {
      await UserService.newRefreshAbatementHistory()
        .then(
          (response) => {
            console.log("response when refreshing abatement history", response);
            if(response.data.code == 1000) {
              this.fetchAbatementHistory();
            } else {
              console.log("error when refreshing abatement history", response.data.message);
            }
          },
        )
    },

    handleRefreshAbatementHistory() {
      this.newUpdateAbatementHistory();
    },

    filterHandle(event) {
      this.filter = { ...event };
      const body = this.buildHighlightsBody();
      if (!isDirectComputeRequest(body) && !body.mp_id) {
        console.warn("Skipping dashboard home fetch: mp_id is required for cached MP flow.");
        return;
      }
      this.fetchData();
      this.fetchAbatementHistory();
    },

    buttonOpenClosehandle(event) {
      this.filterButtonOpenClose = event;
    },
  },
};
</script>

<style scoped>
</style>